import { loadOperationsWithOptions } from '@app/services/api/operations';
import { OperationRegulationsEnum } from '@app/models/api/enums/OperationStatusEnum.js';
import { OperationFinancialInstrumentEnumFR } from '@app/models/api/enums/OperationFinancialInstrumentEnum';

export const load = async ({ url, fetch }) => {
	const operations = await loadOperationsWithOptions(
		url,
		OperationRegulationsEnum.PSI,
		`${OperationFinancialInstrumentEnumFR.ACTIONS},${OperationFinancialInstrumentEnumFR.OBLIGATIONS}, ${OperationFinancialInstrumentEnumFR.TITRES_PARTICIPATIFS}`,
		fetch
	);
	return {
		operations,
		regulation: OperationRegulationsEnum.PSI,
		isPrivateOperations: true
	};
};
